import axios from "axios";
import { createStore, createEffect } from "effector";
import {getCustomUserAgent} from "../../../common/customUserAgent"
import { unpackServerData } from "../../../common/functions";
import { getUuidAndSession } from "../../../common/localStorage";
import { IQueryGrantAccess2account } from "./types"





export const queryDeniedAddSlave = ({ phone, accountId, setLoading, setFailMsg, setSuccessMsg }: IQueryGrantAccess2account) => {
  setLoading(true)
  axios.post("https://izba.kras-abs.ru/api/v2/deniedAddSlave", { //Только КРК
    phone: phone,
    accountId: accountId,
    ...getUuidAndSession(),
  } ,{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      }
    }).then((resp) => {
      let data = unpackServerData(resp.data, "deniedAddSlave.success")
      console.log("queryDeniedAddSlave:success_resp:", resp)
      if(data.failMsg.length == 0) setSuccessMsg("Уведомление об отказе отправлено")
      else setFailMsg(data.failMsg)
      console.log("queryDeniedAddSlave:success_data:", data.data)
      setLoading(false)
      
    }).catch(e => {
      let msg = e.message
      console.log("queryDeniedAddSlave:error1:", e)
      if(e.response && e.response.data) {
        console.log("queryDeniedAddSlave:error2:", e.response.data)
        let data = unpackServerData(e.response.data)
        if(data.failMsg != "") {
          msg = data.failMsg
        }
      }
      console.log("queryDeniedAddSlave:error_msg:", msg)
      setFailMsg(msg)
      setLoading(false)
    })
};

export const queryAddSlave = ({ phone, accountId, setLoading, setFailMsg, setSuccessMsg }: IQueryGrantAccess2account) => {
  setLoading(true)
  axios.post("https://izba.kras-abs.ru/api/v2/setSlaveUserAccs", { //Только КРК
    phone: phone,
    accountId: accountId,
    ...getUuidAndSession(),
  } ,{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      }
    }).then((resp) => {
      let data = unpackServerData(resp.data, "setSlaveUserAccs")
      console.log("queryAddSlave:success_resp:", resp)
      if(data.failMsg.length == 0) setSuccessMsg("Потльзователь успешно привязан к аккаунту")
      else setFailMsg(data.failMsg)
      console.log("queryAddSlave:success_data:", data.data)
      setLoading(false)
    }).catch(e => {
      let msg = e.message
      console.log("queryAddSlave:error1:", e)
      if(e.response && e.response.data) {
        console.log("queryAddSlave:error2:", e.response.data)
        let data = unpackServerData(e.response.data)
        if(data.failMsg != "") {
          msg = data.failMsg
        }
      }
      console.log("queryAddSlave:error_msg:", msg)
      setFailMsg(msg)
      setLoading(false)
    })
};